<template>
  <div id="term_condition">
      <!-- <h2 class="step_question_title">
        Terms and Conditions – Skyline Limited 条款和条件
      </h2> -->
      <p class="claim_text">{{ $t('legal.agreement.paragraph_001') }}</p>
      <p class="claim_text mt-4">{{ $t('legal.agreement.paragraph_002') }}</p>
      <p class="claim_text mt-4">{{ $t('legal.agreement.paragraph_003') }}</p>
      <p class="claim_text mt-4">{{ $t('legal.agreement.paragraph_004') }}</p>
      <p class="claim_text mt-4">{{ $t('legal.agreement.paragraph_005') }}</p>

      <p class="claim_text mt-4">{{ $t('legal.agreement.paragraph_006') }}</p>
      <ul class="step_ul_style">
        <li>{{ $t('legal.agreement.paragraph_007') }}</li>
        <li>{{ $t('legal.agreement.paragraph_008') }}</li>
        <li>{{ $t('legal.agreement.paragraph_009') }}</li>
        </ul>
      <p class="claim_text mt-4">{{ $t('legal.agreement.paragraph_010') }}</p>
      <ul class="step_ul_style">
        <li>{{ $t('legal.agreement.paragraph_011') }}</li>
        <li>{{ $t('legal.agreement.paragraph_012') }}</li>
        <li>{{ $t('legal.agreement.paragraph_013') }}</li>
        </ul>

      <p class="claim_text mt-4">{{ $t('legal.agreement.paragraph_014') }}</p>
      <p class="claim_text mt-4">{{ $t('legal.agreement.paragraph_015') }}</p>
      <p class="step_question_title mt-6">{{ $t('legal.agreement.paragraph_016') }}</p>
      <ol>
        <li class="font-500">{{ $t('legal.agreement.paragraph_017') }}<ul class="step_ul_style">
            <li>{{ $t('legal.agreement.paragraph_018') }}</li>
            <li>{{ $t('legal.agreement.paragraph_019') }}</li>
            <li>{{ $t('legal.agreement.paragraph_020') }}</li>
            <li>{{ $t('legal.agreement.paragraph_021') }}</li>
          </ul>
        </li>
        <li class="font-500 mt-2">{{ $t('legal.agreement.paragraph_022') }}<p class="claim_text mt-2">{{ $t('legal.agreement.paragraph_023') }}</p>

        </li>
        <li class="font-500 mt-2">{{ $t('legal.agreement.paragraph_024') }}<p class="claim_text mt-2">{{ $t('legal.agreement.paragraph_025') }}</p>
        </li>
        <li class="font-500 mt-2">{{ $t('legal.agreement.paragraph_026') }}<p class="claim_text mt-2">{{ $t('legal.agreement.paragraph_027') }}</p>
        </li>
        <li class="font-500 mt-2">{{ $t('legal.agreement.paragraph_028') }}<p class="claim_text mt-2">{{ $t('legal.agreement.paragraph_029') }}</p>
        </li>
        <li class="font-500 mt-2">{{ $t('legal.agreement.paragraph_030') }}<ul class="step_ul_style">
            <li>{{ $t('legal.agreement.paragraph_031') }}</li>
            <li>{{ $t('legal.agreement.paragraph_032') }}</li>
            <li>{{ $t('legal.agreement.paragraph_033') }}</li>
          </ul>
        </li>
        <li class="font-500 mt-2">{{ $t('legal.agreement.paragraph_034') }}<p class="claim_text mt-2">{{ $t('legal.agreement.paragraph_035') }}</p>
          <ul class="step_ul_style">
            <li>{{ $t('legal.agreement.paragraph_036') }}</li>
            <li>{{ $t('legal.agreement.paragraph_037') }}</li>
          </ul>
          <p class="claim_text mt-2">{{ $t('legal.agreement.paragraph_038') }}</p>
        </li>
        <li class="font-500 mt-2">{{ $t('legal.agreement.paragraph_039') }}<p class="claim_text mt-2">{{ $t('legal.agreement.paragraph_040') }}</p>
        </li>
        <li class="font-500 mt-2">{{ $t('legal.agreement.paragraph_041') }}<ul class="step_ul_style">
            <li>{{ $t('legal.agreement.paragraph_042') }}</li>
            <li>{{ $t('legal.agreement.paragraph_043') }}</li>
            <li>{{ $t('legal.agreement.paragraph_044') }}</li>
          </ul>
          <p class="claim_text mt-2">{{ $t('legal.agreement.paragraph_045') }}</p>
        </li>
      </ol>
      <p class="claim_text mt-2">{{ $t('legal.agreement.paragraph_046') }}</p>
      <p class="step_question_title mt-6">{{ $t('legal.agreement.paragraph_047') }}</p>
      <ol>
        <li class="font-500 mt-2">{{ $t('legal.agreement.paragraph_048') }}<ul class="step_ul_style">
            <li>{{ $t('legal.agreement.paragraph_049') }}</li>
            <li>{{ $t('legal.agreement.paragraph_050') }}</li>
            <li>{{ $t('legal.agreement.paragraph_051') }}</li>
          </ul>
        </li>
        <li class="font-500 mt-2">{{ $t('legal.agreement.paragraph_052') }}<p class="my-4">{{ $t('legal.agreement.paragraph_053') }}</p>
          <ul class="step_ul_style">
            <li>{{ $t('legal.agreement.paragraph_054') }}</li>
            <li>{{ $t('legal.agreement.paragraph_055') }}</li>
            <li>{{ $t('legal.agreement.paragraph_056') }}</li>
            </ul>
          <p class="font-500 my-4">{{ $t('legal.agreement.paragraph_057') }}</p>
          <ul class="step_ul_style">
            <li>{{ $t('legal.agreement.paragraph_058') }}</li>
            <li>{{ $t('legal.agreement.paragraph_059') }}</li>
            <li>{{ $t('legal.agreement.paragraph_060') }}</li>
            <li>{{ $t('legal.agreement.paragraph_061') }}</li>
          </ul>
        </li>

        <li class="font-500 mt-2">{{ $t('legal.agreement.paragraph_062') }}<p class="font-500 my-4">{{ $t('legal.agreement.paragraph_063') }}</p>
          <ul class="step_ul_style">
            <p class="font-500 my-4">{{ $t('legal.agreement.paragraph_064') }}</p>
            <li>{{ $t('legal.agreement.paragraph_065') }}</li>
            <li>{{ $t('legal.agreement.paragraph_066') }}</li>
            <li>{{ $t('legal.agreement.paragraph_067') }}</li>
            <li>{{ $t('legal.agreement.paragraph_068') }}</li>
            <li>{{ $t('legal.agreement.paragraph_069') }}</li>
            <li>{{ $t('legal.agreement.paragraph_070') }}</li>
          </ul>
          <ul class="step_ul_style">
            <p class="font-500 my-4">{{ $t('legal.agreement.paragraph_071') }}</p>
            <li>{{ $t('legal.agreement.paragraph_072') }}</li>
            <li>{{ $t('legal.agreement.paragraph_073') }}</li>
            <li>{{ $t('legal.agreement.paragraph_074') }}</li>
          </ul>

        </li>

        <li class="font-500 mt-2">{{ $t('legal.agreement.paragraph_075') }}<p class="font-500 my-4">{{ $t('legal.agreement.paragraph_076') }}</p>
          <ul class="step_ul_style">
            <li>{{ $t('legal.agreement.paragraph_077') }}</li>
            <li>{{ $t('legal.agreement.paragraph_078') }}</li>
          </ul>
        </li>
        <li class="font-500 mt-2">{{ $t('legal.agreement.paragraph_079') }}<p class="claim_text mt-2">{{ $t('legal.agreement.paragraph_080') }}</p>
          <p class="claim_text mt-2">{{ $t('legal.agreement.paragraph_081') }}</p>
          <ul class="step_ul_style">
            <li>{{ $t('legal.agreement.paragraph_082') }}</li>
            <li>{{ $t('legal.agreement.paragraph_083') }}</li>
            <li>{{ $t('legal.agreement.paragraph_084') }}</li>
            <li>{{ $t('legal.agreement.paragraph_085') }}</li>
            <li>{{ $t('legal.agreement.paragraph_086') }}</li>
            <li>{{ $t('legal.agreement.paragraph_087') }}</li>
            <li>{{ $t('legal.agreement.paragraph_088') }}</li>
            <li>{{ $t('legal.agreement.paragraph_089') }}</li>
            <li>{{ $t('legal.agreement.paragraph_090') }}</li>
          </ul>
          <p class="claim_text mt-2">{{ $t('legal.agreement.paragraph_091') }}</p>
          <p class="claim_text mt-2">{{ $t('legal.agreement.paragraph_092') }}</p>
          <p class="claim_text mt-2">{{ $t('legal.agreement.paragraph_093') }}</p>
          <p class="claim_text mt-2">{{ $t('legal.agreement.paragraph_094') }}</p>
          <p class="claim_text mt-2">{{ $t('legal.agreement.paragraph_095') }}</p>
          <p class="claim_text mt-2">{{ $t('legal.agreement.paragraph_096') }}</p>
        </li>
      </ol>
      <p class="claim_text my-2">{{ $t('legal.agreement.paragraph_097') }}</p>
      </div>
</template>

<script>
export default {
}
</script>

<style scoped>
.step_container {
  background: rgb(248, 248, 248);
  padding: 0 1rem;
}

.step_sub_title {
  margin: 20px 0;
  font-size: 17px;
  color: rgba(0, 0, 0, 0.65);
  font-weight: 500;
}
ol{
  margin-top: 1rem;
  list-style-type: decimal;
  padding-left: 25px;
  font-size: 15px;
}

.claim_text{
  font-weight: 300;
  font-size:15px;
  line-height: 24px;
}
.mt-10px{
  margin-top: 10px;
}
.mt-20px{
  margin-top: 20px;
}
.mt-40px{
  margin-top: 40px;
}
.step_ul_style {
  list-style-type: inside;
  list-style-type: disc;
  font-size: 15px;
  padding-left: 2rem;
  font-weight: 300;
  margin-top: 1rem;
}
.step_ul_style li {
  line-height: 24px;
}
.marginX20{
  margin: 20px 0;
}
.generate_btn{
  border: 1px solid #ea7840;
  color: #ea7840;
  padding: 10px;
  font-size: 15px;
  font-weight: 300;
  background-color: #fff;
  outline: none;
  margin-top: 5px;
  transition: .2s;
}
.generate_btn:hover{
  background-color:#ea7840;
  color: #fff;
}
.generate_btn:disabled{
  cursor: not-allowed
}
.general_sign_container{
  margin-top: 10px;
  background: #f8f8f8;
  padding:10px;
}
.general_sign_title{
  font-size: 15px;
  color: rgba(0, 0, 0, 0.65);
  font-weight: 500;
}
.general_sign_url{
  font-weight: 300;
  margin-top:5px;
  white-space: normal;
  word-break: break-all;
}
.copy_link_btn{
  background-color: #ea7840;
  color: #fff;
  padding: 3px;
  font-size: 14px;
  transition: .2s;
  outline: none;
  display: block;
  margin: 5px 0;
}
.copy_link_btn:hover{
  background: #f09f74;
}
.copy_success_text{
  font-weight: 300;
  color: red;
  font-size: 13px;
}
.mod_antd_checkbox {
  font-weight: bold;
  font-size: 17px!important;
  color: rgba(0, 0, 0, 0.85);
}
.mod_antd_checkbox >>> .ant-checkbox-inner{
  border-color: rgba(0, 0, 0, 0.85);
  width: 30px;
  height: 30px;
}
.mod_antd_checkbox >>> .ant-checkbox-inner::after{
  width: 9px;
  height: 18px;
}
.ant-form >>> label{
  font-size: 15px;
}
</style>
